import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDrag } from 'react-dnd';

import { Application, ApplicationStatus } from 'pages/Vacancy/VacancyPage';
import ScoreRing from 'components/ScoreRing/ScoreRing';

import styles from './styles.module.scss';

export default function DraggableRow({ application, fromStatus }: { application: Application; fromStatus: ApplicationStatus }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'APPLICATION',
    item: { type: 'APPLICATION', application, fromStatus },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const { id } = useParams<{ id: string }>(); // vacancy id
  const linkTo = `/vacancy/${id}/application/${application.id}`;

  return (
    <tr
      ref={drag}
      className={`${styles.applicationItem} ${isDragging ? styles.dragging : ''} ${application.is_viewed ? styles.viewed : ''}`}
      style={{ cursor: 'pointer' }}
    >
      <td className={styles.tableTdName}>
        <Link to={linkTo} className={styles.link} target="_blank">
          <span className={styles.tableTdNameName}>
            {application.full_name.length > 64
            ? application.full_name.slice(0, 61) + '...'
            : application.full_name}
          </span>
          <br />
          <span className={styles.tableTdNameEmail}>
            {application.email.length > 64
              ? application.email.slice(0, 61) + '...'
              : application.email}
          </span>
        </Link>
      </td>
      <td>
        <Link to={linkTo} className={styles.link} target="_blank"><ScoreRing score={application.resume_score} /></Link>
      </td>
      <td>
        <Link to={linkTo} className={styles.link} target="_blank"><ScoreRing score={application.test_score} /></Link>
      </td>
      <td>
        <Link to={linkTo} className={styles.link} target="_blank"><ScoreRing score={application.final_score} /></Link>
      </td>
    </tr>
  );
}
